module.exports = __webpack_public_path__ + "img/signalizator-schema-zapojeni.2dc85b3d.webp";